module.exports = __webpack_public_path__ + "static/media/icon-arrow-next.02ae871b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-arrow-next.svg
// module id = 1265
// module chunks = 19